import { Pipe, PipeTransform } from '@angular/core';

import { PhxLocalizationService } from '..';

@Pipe({
  name: 'phxTranslate',
  pure: true,
  standalone: false
})
export class PhxLocalizationPipe implements PipeTransform {

  constructor(private localService: PhxLocalizationService) { }

  transform(value: string, ...args: any[]): string {
    let result = '';
    if (value) {
        result = this.localService.translate(value, ...args);
    }
    return result;
  }

}
